import React from 'react';
import { Phone, MapPin, Clock, Mail } from 'lucide-react';
import { contactInfo } from '../mockData';

const Footer = ({ translations, currentLang }) => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-brown-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid md:grid-cols-3 gap-8 mb-8">
          {/* Brand */}
          <div>
            <h3 className="text-2xl font-bold mb-4">Dere Pastanesi</h3>
            <p className="text-brown-200 leading-relaxed">
              {currentLang === 'tr'
                ? 'Ankara Çankaya\'da yıllardır kaliteli ve taze ürünlerle hizmet veren mahalle pastanesi.'
                : 'A neighborhood pastry shop serving quality and fresh products for years in Çankaya, Ankara.'}
            </p>
          </div>

          {/* Quick Contact */}
          <div>
            <h4 className="text-lg font-semibold mb-4">{translations.contact}</h4>
            <div className="space-y-3">
              <div className="flex items-start gap-3">
                <Phone className="h-5 w-5 mt-1 flex-shrink-0" />
                <a
                  href="tel:+903124463246"
                  className="text-brown-200 hover:text-white transition-colors"
                >
                  {contactInfo.phone}
                </a>
              </div>
              <div className="flex items-start gap-3">
                <Mail className="h-5 w-5 mt-1 flex-shrink-0" />
                <a
                  href={`mailto:${contactInfo.email}`}
                  className="text-brown-200 hover:text-white transition-colors"
                >
                  {contactInfo.email}
                </a>
              </div>
              <div className="flex items-start gap-3">
                <MapPin className="h-5 w-5 mt-1 flex-shrink-0" />
                <span className="text-brown-200">{contactInfo.locationCode}</span>
              </div>
              <div className="flex items-start gap-3">
                <Clock className="h-5 w-5 mt-1 flex-shrink-0" />
                <span className="text-brown-200">{contactInfo.hours[currentLang]}</span>
              </div>
            </div>
          </div>

          {/* Rating */}
          {/* <div>
            <h4 className="text-lg font-semibold mb-4">{translations.contact}</h4>
            <div className="space-y-3">
              <div className="flex items-start gap-3">
                <Phone className="h-5 w-5 mt-1 flex-shrink-0" />
                <a
                  href="tel:+903124463246"
                  className="text-brown-200 hover:text-white transition-colors"
                >
                  {contactInfo.phone}
                </a>
              </div>
              <div className="flex items-start gap-3">
                <MapPin className="h-5 w-5 mt-1 flex-shrink-0" />
                <span className="text-brown-200">{contactInfo.locationCode}</span>
              </div>
              <div className="flex items-start gap-3">
                <Clock className="h-5 w-5 mt-1 flex-shrink-0" />
                <span className="text-brown-200">{contactInfo.hours[currentLang]}</span>
              </div>
            </div>
          </div> */}
        </div>

        <div className="border-t border-brown-700 pt-8 text-center">
          <p className="text-brown-300">
            © {currentYear} Dere Pastanesi. {translations.rights}
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
